import { render } from "./OfflineOverlay.vue?vue&type=template&id=517a8f23&scoped=true"
import script from "./OfflineOverlay.vue?vue&type=script&lang=js"
export * from "./OfflineOverlay.vue?vue&type=script&lang=js"

import "./OfflineOverlay.vue?vue&type=style&index=0&id=517a8f23&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-517a8f23"]])

export default __exports__